export const hashByPrevPage = {
    bikes: "-B",
    motos: "-M",
    interno: "-INT"
}

export const getPrevPage = ({ prevPage = "" }) => {
    const prevPageCleaned = prevPage.split("/")[1]
    return { prevPage: prevPageCleaned, condition: hashByPrevPage[prevPageCleaned] }
}